import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import flex from '../css/module/flex.css';
import modal from '../css/module/modal.css';
import AjaxSpinner from './AjaxSpinner';

class ModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 100, // window width
      height: 50, // window height
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  render() {
    const {
      children,
      loading,
      className,
      small,
      header,
      footer,
      onClose,
      onSubmit,
      disabled,
      extraSmall,
      medium,
      explanation,
      submitButtonText,
      autoHeight,
      showLoaderWithHeader,
      cancelButtonText,
      headerStyle,
      sectionFullHeight,
      customControls,
    } = this.props;

    const width = `${this.state.width - 100}px`;
    const height = `${this.state.height - 50}px`;

    const maxWidth =
      medium && this.state.width > 900
        ? '900px'
        : small
        ? '700px'
        : extraSmall
        ? '500px'
        : width;
    const maxHeight =
      small && this.state.height > 600
        ? '600px'
        : extraSmall
        ? '250px'
        : height;

    if (loading) {
      return (
        <div
          className={`${modal.container} ${className || ''}`}
          style={{
            width,
            height: autoHeight ? 'auto' : height,
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth,
            maxHeight,
          }}
        >
          <AjaxSpinner />
        </div>
      );
    }

    return (
      <div
        className={`${modal.container} ${className || ''}`}
        style={{
          width,
          height: autoHeight ? 'auto' : height,
          maxWidth,
          maxHeight,
        }}
      >
        {!header ? null : (
          <div
            className={`${flex.header} ${modal.header}`}
            style={headerStyle || {}}
          >
            <h1>{header}</h1>
          </div>
        )}
        {showLoaderWithHeader ? (
          <div className={flex.middle}>
            <AjaxSpinner />
          </div>
        ) : !header ? (
          children
        ) : (
          <div className={`${flex.content} ${modal.body}`}>
            {explanation || null}
            <section className={sectionFullHeight ? 'h-100' : ''}>
              {children}
            </section>
          </div>
        )}
        {!footer ? null : (
          <div
            className={`${flex.footer} ${modal.footer}`}
            style={{ borderTop: '1px solid #eee' }}
          >
            {customControls && (
              <div
                onClick={onClose}
                className={`${flex.justifyContentStart} ${flex.alignItemsCenter}`}
              >
                {customControls}
              </div>
            )}
            <div className={flex.justifyContentEnd}>
              <Button
                variant="secondary"
                className="margin-right-10"
                disabled={this.props.disableCancel}
                onClick={onClose}
              >
                {cancelButtonText || 'Cancel'}
              </Button>
              <Button
                id="btnModalSubmit"
                onClick={onSubmit}
                disabled={disabled}
              >
                {submitButtonText || 'Submit'}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ModalContent;
